export enum EDruhDluhopisu {
    DL = 'DL',
    VD = 'VD',
    DS = 'DS',
    NP = 'NP',
    HZL = 'HZL',
    CP = 'CP',
    KD = 'KD',
    OD = 'OD',
    BO = 'BO',
    ZL = 'ZL',
    KO = 'KO',
    PO = 'PO',
    OK = 'OK',
    OJ = 'OJ',
    SD = 'SD',
    SC = 'SC',
    SS = 'SS'
}
